var opposites = {
  top: 'bottom',
  right: 'left',
  bottom: 'top',
  left: 'right'
};

var getDistance = function getDistance(property) {
  return function (_ref) {
    var anchorTo = _ref.anchorTo;
    return anchorTo === opposites[property] ? 'auto' : 0;
  };
};

var expandVertical = function expandVertical(anchorTo) {
  return anchorTo === 'top' || anchorTo === 'bottom';
};

export default {
  root: {
    top: getDistance('top'),
    right: getDistance('right'),
    bottom: getDistance('bottom'),
    left: getDistance('left'),
    fillOpacity: 0,
    height: function height(_ref2) {
      var startingSize = _ref2.startingSize,
          anchorTo = _ref2.anchorTo;
      return expandVertical(anchorTo) ? startingSize : undefined;
    },
    opacity: 0,
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'fixed',
    transition: function transition(_ref3) {
      var transitionMode = _ref3.transitionMode,
          collapseDuration = _ref3.collapseDuration,
          anchorTo = _ref3.anchorTo;
      return ["".concat(expandVertical(anchorTo) ? 'height' : 'width', " ").concat(collapseDuration, "s ").concat(transitionMode), "background ".concat(collapseDuration, "s ").concat(transitionMode), "opacity 0s ".concat(transitionMode, " ").concat(collapseDuration, "s"), "fill-opacity 0s ".concat(transitionMode, " ").concat(collapseDuration, "s"), "visibility ".concat(collapseDuration, "s")].join(', ');
    },
    visibility: 'hidden',
    width: function width(_ref4) {
      var startingSize = _ref4.startingSize,
          anchorTo = _ref4.anchorTo;
      return expandVertical(anchorTo) ? undefined : startingSize;
    },
    zIndex: 100,
    '&:before': {
      borderRadius: 'inherit',
      content: '""',
      display: 'block',
      height: '100%',
      left: 0,
      opacity: 0,
      position: 'absolute',
      top: 0,
      transition: function transition(_ref5) {
        var collapseDuration = _ref5.collapseDuration,
            transitionMode = _ref5.transitionMode;
        return "opacity ".concat(collapseDuration, "s ").concat(transitionMode);
      },
      width: '100%',
      zIndex: -100
    }
  },
  open: {
    fillOpacity: 1,
    height: function height(_ref6) {
      var size = _ref6.size,
          anchorTo = _ref6.anchorTo;
      return expandVertical(anchorTo) ? size : undefined;
    },
    maxHeight: '100vh',
    maxWidth: '100vw',
    opacity: 1,
    pointerEvents: 'inherit',
    transition: function transition(_ref7) {
      var expandDuration = _ref7.expandDuration,
          transitionMode = _ref7.transitionMode,
          anchorTo = _ref7.anchorTo;
      return ["".concat(expandVertical(anchorTo) ? 'height' : 'width', " ").concat(expandDuration, "s ").concat(transitionMode), "background ".concat(expandDuration, "s ").concat(transitionMode), "visibility ".concat(expandDuration, "s")].join(', ');
    },
    visibility: 'visible',
    width: function width(_ref8) {
      var size = _ref8.size,
          anchorTo = _ref8.anchorTo;
      return expandVertical(anchorTo) ? undefined : size;
    },
    '&:before, & $content': {
      fillOpacity: 1,
      opacity: 1
    },
    '& $content': {
      transition: function transition(_ref9) {
        var expandDuration = _ref9.expandDuration,
            transitionMode = _ref9.transitionMode;
        return ["opacity ".concat(expandDuration / 2, "s ").concat(transitionMode, " ").concat(expandDuration / 2, "s"), "fill-opacity ".concat(expandDuration / 2, "s ").concat(transitionMode, " ").concat(expandDuration / 2, "s")].join(', ');
      }
    }
  },
  content: {
    opacity: 0,
    height: '100%',
    overflowY: 'auto',
    position: 'relative',
    transition: function transition(_ref10) {
      var collapseDuration = _ref10.collapseDuration,
          transitionMode = _ref10.transitionMode;
      return ["opacity ".concat(collapseDuration / 2, "s ").concat(transitionMode), "fill-opacity ".concat(collapseDuration / 2, "s ").concat(transitionMode)].join(', ');
    }
  }
};